import React from 'react'
import ReactDom from 'react-dom'
import { IoMdCloseCircle } from 'react-icons/io'
import './EditUserModal.css'

function EditUserModal(props: any) {
    const modalBody: any = (
        <div className="modal_container">
            <div className="modal_header_edit_user">
                <div className="modal_close_icon" onClick={props.handlePopupModal}>
                    <IoMdCloseCircle size={20} color="gray" />
                </div>
            </div>
            
            <div className="modal_body">
                {props.children}
            </div>
        </div>
    )
    const domElement: any = document.getElementById('modal_popup_root');

    return ReactDom.createPortal(modalBody, domElement)
}

export default EditUserModal
